"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toolDef = void 0;
exports.handle = handle;
const dist_1 = require("../../../fs/dist");
const runEvent_1 = require("../../../app/dist/runEvent");
const addStep_1 = require("../../../app/dist/addStep");
exports.toolDef = {
    name: 'loom_add_step',
    description: 'Insert a new step into a plan at a position (append by default, or before/after an existing step id). The step gets a fresh stable slug id and the order is recomputed. title/detail seed the step\'s `### Step N` body detail section. A new (pending) step cannot be inserted before the leading done/cancelled block (immutable history). Allowed on draft/active/implementing/blocked plans. Use this tool to add steps — do not edit plan files directly.',
    inputSchema: {
        type: 'object',
        properties: {
            planId: { type: 'string', description: 'Plan id (ULID e.g. "pl_01J…" or filename stem).' },
            description: { type: 'string', description: 'The new step (the table "Step" cell). Required.' },
            title: { type: 'string', description: 'Optional short heading for the step\'s `### Step N — {title}` detail section. Defaults to the description.' },
            files: { type: 'array', items: { type: 'string' }, description: 'Files this step touches ("Files touched" column).' },
            blockedBy: { type: 'array', items: { type: 'string' }, description: 'Step ids and/or plan ids this step depends on.' },
            satisfies: { type: 'array', items: { type: 'string' }, description: 'Requirement handles (IN/C) this step advances.' },
            detail: { type: 'string', description: 'Optional markdown body for the step\'s `### Step N` detail section.' },
            after: { type: 'string', description: 'Insert immediately after this existing step id. Mutually exclusive with `before`.' },
            before: { type: 'string', description: 'Insert immediately before this existing step id. Mutually exclusive with `after`.' },
        },
        required: ['planId', 'description'],
    },
};
async function handle(root, args) {
    const planId = args['planId'];
    const after = args['after'];
    const before = args['before'];
    if (after !== undefined && before !== undefined) {
        throw new Error('Provide only one of `after` / `before` (or neither, to append).');
    }
    const position = after !== undefined ? { after } : before !== undefined ? { before } : undefined;
    const step = {
        description: args['description'],
        ...(args['title'] !== undefined ? { title: args['title'] } : {}),
        ...(Array.isArray(args['files']) ? { files: args['files'] } : {}),
        ...(Array.isArray(args['blockedBy']) ? { blockedBy: args['blockedBy'] } : {}),
        ...(Array.isArray(args['satisfies']) ? { satisfies: args['satisfies'] } : {}),
        ...(args['detail'] !== undefined ? { detail: args['detail'] } : {}),
    };
    const loadWeaveStrict = async (r, w) => {
        const result = await (0, dist_1.loadWeave)(r, w);
        if (!result)
            throw new Error(`Weave not found: ${w}`);
        return result;
    };
    const deps = {
        loadWeave: loadWeaveStrict,
        runEvent: (weaveId, event) => (0, runEvent_1.runEvent)(weaveId, event, { loadWeave: loadWeaveStrict, saveDocs: dist_1.saveDocs, loomRoot: root }),
        loomRoot: root,
    };
    const result = await (0, addStep_1.addStep)({ planId, step, position }, deps);
    return { content: [{ type: 'text', text: JSON.stringify(result) }] };
}
